export default __webpack_public_path__ + "locales/pt-BR/Common.json?hash=4334d3e0277c0113b93d454f2c729522";